// extracted by mini-css-extract-plugin
module.exports = {"blueLink":"ConfirmGasBackCharityTransfer-module__blueLink___3jHPn"};